import { useState } from "react";
import DetailsContext from "./Details.context";

const DetailsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [event, setEvent] = useState<Sentinel.Timeline.Event>();

  function onClose(): void {
    setOpen(false);
  }

  function onOpen(event: Sentinel.Timeline.Event): void {
    setEvent(event);
    setOpen(true);
  }

  return (
    <DetailsContext.Provider value={{
      open, 
      event,
      onClose,
      onOpen,
    }}>
      {children}
    </DetailsContext.Provider>
  );
};

export default DetailsProvider;
